<template>
   <el-container  style="display: block;background-color: #ffffff;" :style="{'width':screenWidth+'px','height':screenHeight+'px'}">


     <div :style="{'width':screenWidth,'height':screenHeight}" style="display: flex;flex-wrap: wrap;overflow-y: scroll;background-color: #fff;">
      <el-row   style="margin-top: 30px;margin-left: 10%;">
        <template>
          <el-table
        	:data="list"
          height="1000"
        	border
          :style="{'height':screenHeight*0.95+'px'}"
        	style="width: 95%;margin-left: 0;text-align: center;background-color: #ffffff;">

          <el-table-column

            width="300"
            label="id"
            style="background-color: #ffffff;"
             >
             <template slot-scope="scope">
                 <div>{{scope.row.b_id}}</div>
             </template>
          </el-table-column>
          <el-table-column

            width="300"
            label="名称"
            style="background-color: #ffffff;"
             >
             <template slot-scope="scope">
                 <div  @click="dischange(scope.row.name,scope.row.b_id,1)">{{scope.row.name}}</div>
             </template>
          </el-table-column>
          <el-table-column

            width="400"
            label="标签"
            style="background-color: #ffffff;"
             >
             <template slot-scope="scope">
                 <div  @click="dischange(scope.row.ci,scope.row.b_id,2)">{{scope.row.ci}}</div>
             </template>
          </el-table-column>
          <el-table-column

            width="400"
            label="图片组"
            style="background-color: #ffffff;"
             >
             <template slot-scope="scope">
                 <img v-for="(img, index) in scope.row.tu" :key="index" style="width: 120px;height: 120px;object-fit: contain;" :src="img" class="avatar" >
             </template>
          </el-table-column>


          <el-table-column

            width="400"
            label="操作"
            style="background-color: #ffffff;"
             >
             <template slot-scope="scope">
               <el-row>
                 <el-col :span="4" style="text-align: center;margin-top: 15px;" @click.native="toPages(scope.row.b_id)">管理视频</el-col>
                 <el-col :span="12" style="text-align: center;margin-top: 15px;" @click.native="toPaget(scope.row.b_id)">管理文字描述</el-col>

               </el-row>
             </template>
          </el-table-column>
          </el-table>
        </template>

      </el-row>





     </div>


    <div class="beian1">
     <a href="http://beian.miit.gov.cn/state/outPortal/loginPortal.action" rel="noreferrer" target="_blank" style="text-decoration:none;color: #fff;background-color: black;">粤ICP备2024237244号@2024 © 宇宙之幂</a>


    </div>
   <el-dialog
     title="修改"
     :visible.sync="disDialogVisible"
     width="30%"
     center>
     <input type="text" class="searchT" v-model="names"/>
     <span slot="footer" class="dialog-footer">
   	<el-button @click="disDialogVisible = false">取 消</el-button>
   	<el-button type="primary" @click="dodisChange()">确 定</el-button>
     </span>
   </el-dialog>
   </el-container>







</template>


<script>

  export default {
    data() {
      return {
        disDialogVisible:false,
        changeId:0,
        t:0,
        names:'',
        list:[],
        screenWidth : window.innerWidth,
        screenHeight : window.innerHeight,
        vwidth:(window.innerWidth-20)/20,
        vheight : window.innerHeight/200,

      };
    },
    mounted() {


      },
      beforeDestroy() {

      },
    created() {
      var timestamp = new Date().getTime()

      // if(!window.localStorage.getItem('id')){
      //   this.$router.push({ path: '/' })
      // }
      this.loadList()




    },

	methods:{


    toPages(id){
      this.$router.push('/shopvideos?id='+id);
    },
    toPaget(id){
      this.$router.push('/shopvideot?id='+id);
    },
    dischange(name,id,t){
      this.t = t;
      this.changeId = id
      this.names = name
      this.disDialogVisible = true
    },
    dodisChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.changeId,
          name:this.names,
          t:this.t
      	},
      	url:'http://ossp.yoooooo.com/index.php/index/data/shopGuanliChanges'
      })
      .then(res=>{
        if(res.data.code == 200){
          this.disDialogVisible = false
          this.loadList()
        }else{
          this.disDialogVisible = false

        }



      })
      .catch(err=>{

      });
    },
    loadList(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'get',
      	params:{
          name:'宇宙一次幂(深圳)机器人有限公司',


      	},
      	url:'https://tossp.yoooooo.com/index.php/index/data/shopGuanli'
      })
      .then(res=>{
        this.list = res.data.list;

        // console.log(this.list)


      })
      .catch(err=>{

      });
    },
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},



	}


  }
</script>

<style>
.donghuap{
  display: flex;
  justify-content: center;
  /* flex-direction: column; */
  overflow-x: hidden;
  position: relative;
  text-align: center;
  border: 1px solid #BBBBBB;
}
.donghuai{
  display: flex;
  transform: translateX(200%);
  transition: transform 0.4s ease;
  justify-content: center;

}
.adonghua{
  visibility: hidden;
}
.ddonghua{
  transform: translateX(0);
}
.edonghua{
  display: flex;
  transform: translateX(-200%);
  transition: transform 0.6s ease;
  justify-content: center;
}
.el-dropdown-menu__item{
  color: #ffffff;
  font-weight: bold;
  font-family: guanwangdaohang;
}
.popper__arrow{
  display: none;
}

  .content{
  	background: #939AA0;
  	width: 100%;
  	height: 100%;
  }
  body {
  overflow-x:hidden;
  overflow-y:hidden;
  }
  /* .el-scrollbar__wrap{
    background-color: black;
  } */
  .bordered-box{
     overflow-wrap: break-word;
     /* margin-left: 20px; */
  }

 .beian1 {
    position: fixed; /* 定位为固定位置，覆盖整个视窗 */
    color: #616161;
    /* top: 0; */
    left: 42%;
    /* right: 0; */
    bottom: 0;

    z-index: 1000; /* 确保蒙层在其他内容之上 */
  }




</style>



// WEBPACK FOOTER //
// src/components/main/shopvideo.vue